import Icon from '@ant-design/icons';
import { Card, Flex, Image, Popconfirm, Typography } from 'antd';
import { Link } from 'react-router';
import { useTheme } from 'styled-components';
import { Machine } from '../../types';
import { ActionButtonWrapper, StyledField } from './styles';
import { SVGDelete, SVGEdit } from '../../images';
import { useTranslation } from 'react-i18next';

type MachineCardProps = {
  onClick?: (id: string) => void;
  onDelete?: (id: string) => void;
  onEdit?: (id: string) => void;
  data: Machine;
};

const Field = ({ label, value }: { label?: string; value?: string }) => (
  <StyledField gap={10}>
    <span className="label">{label}</span>
    <span>{value || '-'}</span>
  </StyledField>
);

const MachineCard = (props: MachineCardProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { onClick, onDelete, onEdit, data } = props;

  const handleCardClick = () => {
    if (onClick) {
      onClick(data.machineID);
    }
  };
  return (
    <Card
      hoverable
      onClick={handleCardClick}
      style={{ borderRadius: 0, cursor: onClick ? 'pointer' : 'default' }}
    >
      <Flex align="center" gap={24}>
        <Flex
          style={{
            backgroundColor: '#fff',
            height: 90,
            overflow: 'hidden',
            flexShrink: 0,
          }}
          align="center"
          justify="center"
        >
          {onClick ? (
            <Image
              width={120}
              src={data?.images?.[0]?.url}
              preview={false}
              fallback="/placeholder.png"
              style={{ objectFit: 'contain', maxHeight: '100%' }}
            />
          ) : (
            <Link to={`${data.machineID}`}>
              <Image
                width={120}
                src={data?.images?.[0]?.url}
                preview={false}
                fallback="/placeholder.png"
                style={{ objectFit: 'contain', maxHeight: '100%' }}
              />
            </Link>
          )}
        </Flex>
        <Flex flex={1} vertical gap={16}>
          <Flex gap={20}>
            {onClick ? (
              <Typography.Text style={{ color: theme.antd.colorPrimary }}>
                {data.name}
              </Typography.Text>
            ) : (
              <Link to={`${data.machineID}`}>
                <Typography.Text style={{ color: theme.antd.colorPrimary }}>
                  {data.name}
                </Typography.Text>
              </Link>
            )}

            <Field label={t('alias')} value={data.alias} />
          </Flex>
          <Flex gap={24}>
            <Field label={t('template')} value={data.templateName} />
            <Field label={t('machine_type')} value={data.type} />
            <Field label={t('manufacturer')} value={data.manufacturer} />
          </Flex>
        </Flex>
        <Flex gap={8}>
          {onEdit && (
            <ActionButtonWrapper
              onClick={(e) => {
                onEdit(data.machineID);
              }}
              style={{ cursor: 'pointer' }}
              title={t('edit')}
            >
              <Icon component={SVGEdit} />
            </ActionButtonWrapper>
          )}

          {onDelete && (
            <Popconfirm
              placement="bottom"
              title={`Are you sure you want to delete ${data.name}`}
              okText={t('yes')}
              cancelText={t('no')}
              onConfirm={(e) => onDelete(data.machineID)}
            >
              <ActionButtonWrapper
                style={{ cursor: 'pointer' }}
                title={t('delete')}
              >
                <Icon component={SVGDelete} />
              </ActionButtonWrapper>
            </Popconfirm>
          )}
        </Flex>
      </Flex>
    </Card>
  );
};

export default MachineCard;
